(() => {
  class PremiumHeroSlider {
    constructor(root) {
      if (!root || root.dataset.heroReady === 'true') return;
      this.root = root;
      this.slides = [...root.querySelectorAll('[data-hero-slide]')];
      this.dots = [...root.querySelectorAll('[data-hero-dot]')];
      this.index = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
      this.delay = Number(root.dataset.delay) || 5500;
      this.autoplay = root.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.timer = null;
      this.pointerStart = null;
      this.touchStart = null;
      root.dataset.heroReady = 'true';
      this.syncMobileAspect();
      if (this.slides.length < 2) return;

      root.querySelector('[data-hero-prev]')?.addEventListener('click', () => this.go(this.index - 1, true));
      root.querySelector('[data-hero-next]')?.addEventListener('click', () => this.go(this.index + 1, true));
      this.dots.forEach((dot) => dot.addEventListener('click', () => this.go(Number(dot.dataset.heroDot), true)));
      root.addEventListener('mouseenter', () => this.stop());
      root.addEventListener('mouseleave', () => this.start());
      root.addEventListener('focusin', () => this.stop());
      root.addEventListener('focusout', (event) => {
        if (!root.contains(event.relatedTarget)) this.start();
      });
      root.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'pen') this.pointerStart = event.clientX;
      }, { passive: true });
      root.addEventListener('pointerup', (event) => {
        if (this.pointerStart === null) return;
        const distance = event.clientX - this.pointerStart;
        this.pointerStart = null;
        if (Math.abs(distance) > 45) this.go(this.index + (distance < 0 ? 1 : -1), true);
      }, { passive: true });
      root.addEventListener('pointercancel', () => { this.pointerStart = null; }, { passive: true });
      root.addEventListener('touchstart', (event) => {
        this.touchStart = event.changedTouches?.[0]?.clientX ?? null;
      }, { passive: true });
      root.addEventListener('touchend', (event) => {
        if (this.touchStart === null) return;
        const touchEnd = event.changedTouches?.[0]?.clientX ?? this.touchStart;
        const distance = touchEnd - this.touchStart;
        this.touchStart = null;
        if (Math.abs(distance) > 35) this.go(this.index + (distance < 0 ? 1 : -1), true);
      }, { passive: true });
      root.addEventListener('touchcancel', () => { this.touchStart = null; }, { passive: true });
      this.start();
    }

    go(nextIndex, restart = false) {
      const next = (nextIndex + this.slides.length) % this.slides.length;
      if (next === this.index) return;
      this.slides[this.index].classList.remove('is-active');
      this.slides[this.index].setAttribute('aria-hidden', 'true');
      this.dots[this.index]?.classList.remove('is-active');
      this.dots[this.index]?.setAttribute('aria-selected', 'false');
      this.index = next;
      this.slides[this.index].classList.add('is-active');
      this.slides[this.index].setAttribute('aria-hidden', 'false');
      this.dots[this.index]?.classList.add('is-active');
      this.dots[this.index]?.setAttribute('aria-selected', 'true');
      this.syncMobileAspect();
      if (restart) {
        this.stop();
        this.start();
      }
    }

    syncMobileAspect() {
      const aspect = this.slides[this.index]?.dataset.mobileAspect;
      if (aspect) this.root.style.setProperty('--mobile-hero-aspect', aspect);
    }

    start() {
      if (!this.autoplay || this.timer || document.hidden) return;
      this.timer = window.setInterval(() => this.go(this.index + 1), this.delay);
    }

    stop() {
      if (!this.timer) return;
      window.clearInterval(this.timer);
      this.timer = null;
    }
  }

  const init = (scope = document) => {
    scope.querySelectorAll?.('[data-premium-hero]').forEach((root) => new PremiumHeroSlider(root));
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();

  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:block:select', (event) => {
    const slide = event.target.closest?.('[data-hero-slide]');
    const root = event.target.closest?.('[data-premium-hero]');
    if (!slide || !root) return;
    const index = [...root.querySelectorAll('[data-hero-slide]')].indexOf(slide);
    root.querySelector(`[data-hero-dot="${index}"]`)?.click();
  });
})();
